/* rhoneprints: a little cat now and then pops its head up from behind an image or button, and ducks when the cursor comes near */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* 19 x 8 sprite. # fur, s stripe, e eye, p pupil, n nose, w whisker, k closed-eye line, . empty */
  var OPEN = [
    '....##.......##....',
    '....###.....###....',
    '...####s#s#s####...',
    '...#############...',
    '...##ee#####ee##...',
    '...##pp#####pp##...',
    'ww.#####nnn#####.ww',
    '..w#############w..'
  ];
  /* closed eyes: row 4 plain fur, row 5 a thin line where the eyes were */
  var SHUT = OPEN.slice();
  SHUT[4] = '...#############...';
  SHUT[5] = '...##kk#####kk##...';

  var CATS = {
    black:  { '#': '#2a2a36', s: '#3f3f52', e: '#d8ff4a', p: '#0a0a10', n: '#ff8fb3', w: '#f2efff', k: '#8a8aa0' },
    orange: { '#': '#e8873a', s: '#b85a1c', e: '#9dff7a', p: '#0a0a10', n: '#ff8fb3', w: '#f2efff', k: '#7a3a10' },
    grey:   { '#': '#8e93a3', s: '#626878', e: '#ffcc33', p: '#0a0a10', n: '#ff8fb3', w: '#f2efff', k: '#3c4152' },
    white:  { '#': '#f2efff', s: '#c9c5dd', e: '#58c8ff', p: '#0a0a10', n: '#ff8fb3', w: '#f2efff', k: '#8a86a3' }
  };
  var NAMES = Object.keys(CATS);

  function svg(rows, pal, cell) {
    var out = '';
    rows.forEach(function (r, y) {
      for (var x = 0; x < r.length; x++) {
        var c = r.charAt(x);
        if (c === '.') continue;
        var col = pal[c];
        if (!col) continue;
        out += '<rect x="' + x * cell + '" y="' + y * cell + '" width="' + cell + '" height="' + cell + '" fill="' + col + '"/>';
      }
    });
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + 19 * cell + '" height="' + 8 * cell + '" shape-rendering="crispEdges" style="display:block">' + out + '</svg>';
  }

  var PICK = '.cat-card__img, .card__media, .intro__photo, .product__media-item, .button, .intro__sound, .intro__links a, .cm__bar';
  var mx = -999, my = -999, cur = null;
  window.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; }, { passive: true });

  function candidates() {
    var list = document.querySelectorAll(PICK);
    var vh = window.innerHeight, out = [];
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.closest('.gl-left, .gl-sound, header, .header-wrapper, cart-notification')) continue;
      if (!el.offsetParent) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 70 || r.top < 130 || r.top > vh - 40) continue;
      if (mx > r.left - 50 && mx < r.right + 50 && my > r.top - 70 && my < r.bottom + 50) continue;
      out.push({ el: el, r: r });
    }
    return out;
  }

  function spawn() {
    if (cur || document.hidden) return;
    var c = candidates();
    if (!c.length) return;
    var t = c[Math.floor(Math.random() * c.length)];
    var name = NAMES[Math.floor(Math.random() * NAMES.length)];
    var cell = window.innerWidth < 750 ? 3 : 4;
    var w = 19 * cell, h = 8 * cell;
    var pad = Math.min(30, t.r.width * 0.12);
    var span = Math.max(0, t.r.width - w - pad * 2);
    var left = t.r.left + pad + Math.random() * span + window.scrollX;
    var top = t.r.top + window.scrollY - h + 1;

    var box = document.createElement('div');
    box.setAttribute('aria-hidden', 'true');
    box.style.cssText = 'position:absolute;pointer-events:none;overflow:hidden;z-index:9990;left:' + left + 'px;top:' + top + 'px;width:' + w + 'px;height:' + h + 'px';
    var inner = document.createElement('div');
    inner.style.cssText = 'transform:translateY(100%);transition:transform .32s steps(4)';
    var a = document.createElement('div'), b = document.createElement('div');
    a.innerHTML = svg(OPEN, CATS[name], cell);
    b.innerHTML = svg(SHUT, CATS[name], cell);
    b.style.display = 'none';
    inner.appendChild(a); inner.appendChild(b);
    box.appendChild(inner);
    document.body.appendChild(box);

    var dead = false, timers = [];
    function later(fn, ms) { var id = setTimeout(fn, ms); timers.push(id); }
    function leave(fast) {
      if (dead) return;
      dead = true;
      timers.forEach(clearTimeout);
      inner.style.transitionDuration = fast ? '.14s' : '.32s';
      inner.style.transform = 'translateY(100%)';
      setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); cur = null; }, fast ? 200 : 380);
    }
    function blink() { a.style.display = 'none'; b.style.display = 'block'; later(function () { a.style.display = 'block'; b.style.display = 'none'; }, 160); }
    cur = { leave: leave };

    requestAnimationFrame(function () { requestAnimationFrame(function () { inner.style.transform = 'translateY(0)'; }); });
    later(blink, 900 + Math.random() * 700);
    if (Math.random() < 0.5) later(blink, 2200 + Math.random() * 800);
    later(function () { leave(false); }, 3000 + Math.random() * 2600);

    /* duck if the cursor gets near the cat or the thing it's hiding behind */
    var watch = setInterval(function () {
      if (dead) { clearInterval(watch); return; }
      var r = t.el.getBoundingClientRect();
      var cx = left - window.scrollX, cy = top - window.scrollY;
      var nearEl = mx > r.left - 30 && mx < r.right + 30 && my > r.top - 30 && my < r.bottom + 30;
      var nearCat = mx > cx - 40 && mx < cx + w + 40 && my > cy - 50 && my < cy + h + 20;
      if (nearEl || nearCat) { clearInterval(watch); leave(true); }
    }, 90);
    document.addEventListener('touchstart', function once() { document.removeEventListener('touchstart', once); leave(true); }, { passive: true });
  }

  function loop() {
    setTimeout(function () { spawn(); loop(); }, 4000 + Math.random() * 6000);
  }
  setTimeout(loop, 4500);
  window.__glPeek = spawn;
})();
